<template>
    <canvas ref="chart"></canvas>
</template>
<script>
import Chart from "chart.js"
export default {
    name: 'chart',
    props: ["type", "data", "options"],
    data(){
        return {
            chart: null
        }
    },
    mounted() {
        this.chart = new Chart(this.$refs.chart, {
            type: this.type || 'doughnut',
            data: this.data,
            options: this.options
        })
    },
    watch:{
        data:{
            handler: function(newVal){
                if(this.chart){
                    this.chart.data = newVal
                    this.chart.update()
                }
            },
            deep:true
        }
    }
}
</script>